import { dateOnlyToDate } from '@aston/foundation';
import { ISubsidiaryUser } from '@aston/middle-users-admin';

import { ISubsidiaryUserApi } from '../models/api';


export function mapToUserItemModel(apiModel: ISubsidiaryUserApi): ISubsidiaryUser {
	return {
		...apiModel,
		inactivityBeginDate: dateOnlyToDate(apiModel.inactivityBeginDate),
		inactivityEndDate: dateOnlyToDate(apiModel.inactivityEndDate),
	};
}
